import _ from 'lodash'

//getFieldProps
export const getElementPropsByUID = (state, uid, path, defValue = null) => {
  try {
    let elem = getFieldByUID(state, uid)
    if (!elem) {
      return null
    }
    return elem.getIn(path, defValue)
  } catch (err) {
    console.error(err)
  }
  return defValue
}

export const getFieldByUID = (state, uid) => {
  try {
    let elem = state.getIn(['project', 'Settings', 'elements', uid])
    if (!elem) {
      elem = state.getIn(['pages', state.get('page'), 'Props', 'elements', uid])
    }
    if (!elem || !elem.get('type')) {
      return null
    }
    return elem
  } catch (err) {
    console.error(err)
  }
  return null
}
